module.exports = __webpack_public_path__ + "static/img/footer_banner_btn2.2c80fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/footer_banner_btn2.png
// module id = WzWL
// module chunks = 34